export default __webpack_public_path__ + "static/media/tiger_10.aca1f538.mp3";